<template>
  <div class="ioi-table-wrapper">
    <!-- <\el-table
      ref="table"
      :data="data"
      width="100%"
      class="border ioi-table"
      @row-click="(row) => this.$router.push({
        name: 'equities.edit',
        params: {
          id: row.id,
        },
      })"
    >
      <\el-table-column
        class-name="ioi-table__expand"
        type="expand"
        width="16"
      >
        <template>
          <div class="d-flex ioi-table__details">
            <div class="ioi-table__details__item">
              <div class="ioi-table__details__item__header">
                <b>
                  Ex
                </b>
              </div>
              <div class="ioi-table__details__item__value">
                Ex content
              </div>
            </div>
            <div class="ioi-table__details__item">
              <div class="ioi-table__details__item__header">
                <b>
                  Ex
                </b>
              </div>
              <div class="ioi-table__details__item__value">
                Ex content
              </div>
            </div>
          </div>
        </template>
      </\el-table-column>

      <\el-table-column
        class-name="ioi-table__checkbox"
        width="32"
      >
        <template slot="header">
          <t-checkbox @click.native.stop />
        </template>
        <template>
          <t-checkbox @click.native.stop />
        </template>
      </\el-table-column>

      <\el-table-column
        label="Code"
        prop="isin"
        width="150"
      />

      <\el-table-column
        label="Stock Name"
        prop="securityNameBBG"
      />

      <\el-table-column
        label="B/S"
        width="75"
      >
        <template slot-scope="scope">
          <span
            v-if="scope.row.side"
            class="ioi-badge"
            :class="{'ioi-badge--buy': scope.row.side === 'BUY', 'ioi-badge--sell': scope.row.side === 'SELL'}"
          >
            {{ scope.row.side }}
          </span>
        </template>
      </\el-table-column>

      <\el-table-column
        label="Price"
        prop="price"
        width="100"
      />

      <\el-table-column
        label="Qty."
        prop="quantity"
        width="75"
      />

      <\el-table-column
        label="Broker name"
        prop="firmName"
        width="150"
      />

      <\el-table-column
        label="Qualifier"
        prop="qualifierName"
        width="200"
      />

      <\el-table-column
        label="Status"
        width="100"
      >
        <template v-slot="{ row }">
          <div
            class="ioi-badge"
            :class="`status-${row.status ? row.status.toLowerCase() : 'new'}`"
          >
            {{ row.status || 'NEW' }}
          </div>
        </template>
      </\el-table-column>
    </\el-table> -->
  </div>
</template>
<script>
import moment from 'moment'
import Date from '@/directives/date'

export default {
  components: {
  },
  directives: {
    Date,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      allSelected: false,
    }
  },
  computed: {
  },
  methods: {
    onRowClick (row) {
      this.$refs.table.toggleRowExpansion(row)
    },

    selectAll () {
      console.log('selectAll')
    },

    formatDate (timestamp) {
      return timestamp ? moment(timestamp).format('LLL') : ''
    },
  },
}
</script>

<style lang="scss">
.ioi-table {
  .status {
    &-new {
      color: #257524;
      border-color: $green;
    }

    &-updated {
      color: #101820;
      border-color: #0059d9;
    }

    &-cancelled {
      color: #b72a0f;
      border-color: #f34220;
    }
  }
  .el-icon {
    display: none;
  }

  .chevron-down {
    display: block;
  }

  .chevron-up {
    display: none;
  }

  th, td {
    padding: 0 !important;
    height: 40px;
    .cell {
      font-size: 14px;
      // line-height: 12px;
    }

    .checkbox {
      margin: 0;
    }
  }

  .\el-table {
    &__row {
      &.expanded {
        .chevron-down {
          display: none;
        }
        .chevron-up {
          display: block;
        }
      }
    }
  }

  &__details {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
    padding-left: 2.5rem;
    // padding-right: calc(2.5rem + 40px);
    padding-right: 2.5rem;
    justify-content: space-between;
    font-size: 14px;
    &__item {
      padding: 0 8px;
      &:last-child {
        width: 168px;
      }
    }
  }

  .ioi-table__checkbox {
    .cell {
      padding: 0 !important;
    }
  }

  .ioi-badge {
    display: inline-flex;
    height: 24px;
    padding: 0 0.5rem;
    border-width: 1px;
    border-style: solid;
    border-radius: 4px;
    font-size: 10px;
    &--buy {
      background: $stats-bg;
      border-color: #c4daff;
    }
    &--sell {
      background: #fef5fa;
      border-color: #f495ce;
    }
  }
}
</style>

